<div class="wo-remove-control-button">
  <div class="wo-remove-control-button-content">
    <ng-content/>
  </div>
  <div>
    <wo-remove-circle-icon-button
      *ngIf="!inactive"
      class="wo-remove-control-button__button"
      (click)="remove.emit()"
      [tooltip]="tooltip"
      [size]="size"
    />
  </div>
</div>
